function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M13.6,13a1,1,0,1,1-1,1,1,1,0,0,1,1-1ZM24,10.1v7.8a.9.9,0,0,1-.9.9h-.28V22a2.006,2.006,0,0,1-2,2H2a2.006,2.006,0,0,1-2-2V6A2.014,2.014,0,0,1,1.52,4.06c.02-.02.05-.02.07-.03L17.17.06a2.013,2.013,0,0,1,2.5,1.96V4h1.15a2.006,2.006,0,0,1,2,2V9.2h.28A.9.9,0,0,1,24,10.1ZM7.07,4H18.34V2.02a.673.673,0,0,0-.26-.54.694.694,0,0,0-.59-.13ZM21.49,18.8H14.4a4.8,4.8,0,0,1,0-9.6h7.09V6a.67.67,0,0,0-.67-.67H2A.67.67,0,0,0,1.33,6V22a.67.67,0,0,0,.67.67H20.82a.67.67,0,0,0,.67-.67Zm1.18-8.27H14.4a3.47,3.47,0,0,0,0,6.94h8.27Z",
  transform: "translate(0 -0.001)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23.999,
    viewBox: "0 0 24 23.999"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/cash.927cf9c5.svg";
export { SvgComponent as ReactComponent };